import { render, staticRenderFns } from "./CardNutritionalInformation.vue?vue&type=template&id=6253af70"
import script from "./CardNutritionalInformation.vue?vue&type=script&lang=js"
export * from "./CardNutritionalInformation.vue?vue&type=script&lang=js"
import style0 from "./CardNutritionalInformation.vue?vue&type=style&index=0&id=6253af70&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6253af70')) {
      api.createRecord('6253af70', component.options)
    } else {
      api.reload('6253af70', component.options)
    }
    module.hot.accept("./CardNutritionalInformation.vue?vue&type=template&id=6253af70", function () {
      api.rerender('6253af70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/components/CardNutritionalInformation.vue"
export default component.exports